import { createContext } from 'react';

export const LagoonContext = createContext();
